import React from 'react'
import { useSelector } from 'react-redux';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../../redux/library/selector';

export default function ProjectBasicInfoComponent ({selectedProject,handleFormChange,handleInnerFormChange}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedProject?.Name}
          />
            <InputContainer
                        isDateTimePicker
                        label="Start Date TimeInUtc"
                        name="StartDateTimeInUtc"
                        onValueChange={(event: any) => {
                          handleInnerFormChange(
                             event.target.value,
                            'StartDateTimeInUtc'
                          );
                        }}
                        type="date"
                        value={selectedProject?.StartDateTimeInUtc}
                      />
                     <InputContainer
                        isDateTimePicker
                        label="End Date TimeInUtc"
                        name="EndDateTimeInUtc"
                        onValueChange={(event: any) => {
                          handleInnerFormChange(
                             event.target.value,
                            'EndDateTimeInUtc'
                          );
                        }}
                        type="date"
                        value={selectedProject?.EndDateTimeInUtc}
                      />
         <InputContainer
                          label="Project Priority"
                          labelField="Text"
                          list={libraryData?.result?.ProjectPriority}
                          onValueChange={( event: any) => {
                            handleInnerFormChange(
                             event.target.value,
                             'ProjectPriorityId'
                           )
                          }}
                          type="select"
                          optionName="Choose Project priority"
                           valueField="Value"
                          value={selectedProject?.ProjectPriorityId}
                          
                      />
                       <InputContainer
                          label="Project State"
                          labelField="Text"
                          list={ libraryData?.result?.ProjectState}
                          onValueChange={( event: any) => {
                            handleInnerFormChange(
                             event.target.value,
                             'ProjectStateId'
                           )
                          }}
                            optionName="Choose Project State"
                          type="select"
                           valueField="Value"
                          value={selectedProject?.ProjectStateId}
                          
                      />
         
         <div className='col-span-full'>
        <InputContainer
       
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Description',

              )
            }}
              type="text"
            value={selectedProject?.Description}
        /></div>
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}